// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc; /* Very light gray/slate for contrast */
  font-family: 'Roboto', sans-serif;
  padding: 20px;
}

.login-card {
  background: #ffffff; /* Card remains white */
  border-radius: 12px;
  padding: 48px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04), 0 2px 10px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.login-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  text-align: center;
  margin-bottom: 2.5rem;
  letter-spacing: -0.02em;
}

.login-card .form-group {
  margin-bottom: 1.5rem;
}

.login-card label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0.5rem;
}

.login-card input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  color: #1e293b;
  background: #ffffff;
  transition: all 0.2s ease;
}

.login-card input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.btn-login {
  width: 100%;
  padding: 14px;
  background-color: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 1.5rem;
}

.btn-login:hover:not(:disabled) {
  background-color: #1d4ed8;
  transform: translateY(-1px);
}

.btn-login:active:not(:disabled) {
  transform: translateY(0);
}

.btn-login:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
}

.error-msg {
  background-color: #fff1f2;
  border: 1px solid #ffe4e6;
  color: #e11d48;
  padding: 14px;
  border-radius: 8px;
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

@media (max-width: 480px) {
  .login-card {
    padding: 32px 24px;
    border-radius: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoginPage.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAE,uCAAuC;EAClE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,mBAAmB,EAAE,uBAAuB;EAC5C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,2EAA2E;EAC3E,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');\n\n.login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8fafc; /* Very light gray/slate for contrast */\n  font-family: 'Roboto', sans-serif;\n  padding: 20px;\n}\n\n.login-card {\n  background: #ffffff; /* Card remains white */\n  border-radius: 12px;\n  padding: 48px;\n  width: 100%;\n  max-width: 440px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04), 0 2px 10px rgba(0, 0, 0, 0.02);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.login-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1e293b;\n  text-align: center;\n  margin-bottom: 2.5rem;\n  letter-spacing: -0.02em;\n}\n\n.login-card .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.login-card label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748b;\n  margin-bottom: 0.5rem;\n}\n\n.login-card input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  color: #1e293b;\n  background: #ffffff;\n  transition: all 0.2s ease;\n}\n\n.login-card input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.btn-login {\n  width: 100%;\n  padding: 14px;\n  background-color: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-top: 1.5rem;\n}\n\n.btn-login:hover:not(:disabled) {\n  background-color: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.btn-login:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-login:disabled {\n  background-color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.error-msg {\n  background-color: #fff1f2;\n  border: 1px solid #ffe4e6;\n  color: #e11d48;\n  padding: 14px;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 32px 24px;\n    border-radius: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
